<template>
  <div class="min-h-screen bg-gray-50 pt-20">
    <PrivacyPolicy />
  </div>
</template>

<script setup lang="ts">
import PrivacyPolicy from '../components/legal/PrivacyPolicy.vue';
</script>
